// AnimatedNumber.jsx
import { useRef, useEffect } from 'react';

export default function AnimatedNumber({
  value,
  decimals = 2,
  duration = 1500,
  formatter,
  className,
}) {
  const spanRef = useRef(null);

  useEffect(() => {
    const node = spanRef.current;
    if (!node) return;

    const target = Number(value) || 0;
    const steps = Math.max(30, duration / 16);
    const stepVal = target / steps;
    let current = 0;
    let raf;

    const tick = () => {
      current = Math.min(current + stepVal, target);
      node.textContent = formatter(current.toFixed(decimals));

      if (current < target) {
        raf = requestAnimationFrame(tick);
      } else {
        node.textContent = formatter(target.toFixed(decimals));
      }
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, decimals, duration, formatter]);

  return <span ref={spanRef} className={className} />;
}